import { Alert } from '@ksyos/design-system';
import type { HolterExaminationRequestContentKeys } from '@common/validation/customControls/cardiology/holter/holterExaminationRequestSchemas';
import type { ContentComponentsMap } from '@frontend/formEngine/editForm/editForm.types';

export function getExaminationRequestContentComponents(): ContentComponentsMap<HolterExaminationRequestContentKeys> {
    const map: ContentComponentsMap<HolterExaminationRequestContentKeys> = new Map();
    map.set(
        'adviesAlert',
        <Alert
            appearance="info"
            hasIcon={true}
        >
            <Alert.Text
                as="p"
                fontWeight="bold"
                marginBottom={2}
            >
                Aanvullende informatie nodig
            </Alert.Text>
            <Alert.Text
                as="p"
                fontWeight="normal"
            >
                Voor goed meedenkadvies van de specialist is een adviesvraag en nog wat aanvullende informatie nodig. Er
                start automatisch een consult zodra de cardioloog een afwijking vaststelt. Je ontvangt dan aanvullend
                advies bij de diagnose.
            </Alert.Text>
        </Alert>
    );

    return map;
}
